<template>
    <v-dialog v-model="dialog" max-width="500px">
        <v-card>
            <v-card-title
                class="text-h5 aviso"
                style="
                    justify-content: center;
                    background: #1d2735;
                    color: white;
                    margin-bottom: 1rem;
                "
            >
                {{ title }}
            </v-card-title>
            <v-card-text
                ><h2 style="text-align: center">{{ message }}</h2></v-card-text
            >
            <v-card-actions class="justify-center">
                <v-btn color="error" large @click="dialog = false"
                    >Cancelar</v-btn
                >
                <v-btn color="success" large @click="$emit('confirm')"
                    >Confirmar</v-btn
                ></v-card-actions
            >
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props: ["value", "message", "title"],
    data() {
        return {
            dialog: false,
        };
    },
    created() {
        if (this.value != null) {
            this.dialog = this.value;
        }
    },
    watch: {
        dialog(val) {
            this.$emit("input", val);
        },
        value(val) {
            this.dialog = val;
        },
    },
};
</script>
